// Client for the CTR Optimizer. Read-only — the fixes are made in the listing
// tools, not here.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/ctr`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon account not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.connected === false) throw new NotConnectedError(data.error);
  if (!res.ok || !data.success) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });

// Surface 1 — every product ranked by clicks lost.
export const getProducts = (token, params) =>
  call(`${BASE}/products?${query(params)}`, { headers: headers(token) });

// Surface 2 — one product, its diagnosis and change history.
export const getProduct = (token, asin, params) =>
  call(`${BASE}/product/${encodeURIComponent(asin)}?${query(params)}`,
       { headers: headers(token) });

// Surface 3 — every change in the period and what followed it.
export const getChanges = (token, params) =>
  call(`${BASE}/changes?${query(params)}`, { headers: headers(token) });
